import { QueueElement } from 'src/core/queue/domain/queue-element';
import { Task } from 'src/core/master-data/domain/task';

export abstract class TaskQueueElement extends QueueElement {
  task: Task;
}
